import { DeviceConfig, mainDeviceConfig, TypesString } from './device-config';

export class CharglinkDevice implements DeviceConfig {
	config: mainDeviceConfig = {
		sct_device_type: 1,
		isIotah: false,
		isCharglink: true,
		isBattlink: false,
		isBrm: false,
		is_eMeter: false,
		is_iotemeter: false,
		couldHaveStudy: false,
		hasTypes: false,
		typeString: 'ChargLink',
		translationPath: 'chargLinkDevice.',
		imageFolder: '/chargLink/charger',
		logoStyleClass: 'charglink-logo',
		mapColor: '#a5d662',
		setLastMaintenanceDate: true,
		hasMaintenanceSchedule: true,
		hasBatterySettings: false,
		CO2data: false,
		permissionMapperKey: '',
		mapperOverrideFile: "",
		supportIncorrectEvent: true,
		hasLoadScheduling: false,
		hasRequestManageDevice: true,
		hasManageDevice: true,
		deviceSettingTabs: ['info','deviceSettings','cal','networkingSettings','networking','billedKWHrsSettings','maintenanceSchedule','official-reporting','connectivityFrequency'],
		hasLoadPowerStatusStop: false,
		hasImCalibration: false,
		fields: {
			kwhr: 'charge_kwhr',
			hasMaxChargerKw: true,
			hasTemperatureSensor: false,
			hasShiftSchedule: false,
			hasWaterLevel: false,
			hasHallEffect: true,
			trickleVoltage: false,
			cvTargetVoltage: false,
			fiTargetVoltage: false,
			eqVoltage: false,
			trickleCurrentRate: false,
			ccRate: false,
			cvEndCurrentRate: false,
			cvCurrentStep: false,
			fiCurrentRate: false,
			eqCurrentRate: false,
			batteryCapacity: false,
			batteryType: false,
			numberOfCells: false,
			batteryTemperatureCompensationInMv: false,
			fiDt: false,
			fiDv: false,
			liftCurrentThresholdPercentage: false,
			liftCurrentThresholdValue: false,
			liftCurrentThresholdDeltaPercentage: false,
			liftCurrentThresholdDeltaValue: false,
			deadManTime: false,
			returnFactor: true,
			batteryEfficiency: true,
			chargerEfficiency: true,
			deadManCurrentLimit: false,
			chargerType: true,
			chargerVoltage: true,
		},
		requiredFields: {
			truckType: false,
			truckManufacturer: false,
			truckManufacturingYear: true,
			truckManufacturingMonth: true,
			currentLiftLowerThreshold: false,
			currentLiftUpperThreshold: false,
		},
		incorrectEvent: {
			type: 'inuse',
		},
		quarterlyUsage: {
			hasTypeFilter: false,
			hasYearFilter: false,
			performanceChartType: 'c',
			hasChartLegend: true,
			chartGridColumns: 6,
			hasTotalTravelTimeChart: false,
			hasTotalLiftTimeChart: false,
			period: 'quarter',
			perfAnalyticsKey: 'perf_analytic.quarters_utilization_score',
		},
		reporting: {
			device: 'chargLink',
		},
		dailyDetails: {
			hasField: {
				billed_kwh: false,
				accurate_inuse_seconds: false,
				lift_time: false,
				travel_time: false,
				ah_h: false,
				ebu: false,
				eq: false,
				missed_fi: false,
			},
			hasOrPowerStudy: {
				min_soc: false,
			},
			hasTypes: {
				endVoltage: false,
				chargerEndVoltage: false,
				idleTimes: false,
			},
			useBilledKwh: true
		},
		events: {
			hasFields: {
				billed_kwh: false,
				lift_time: false,
				travel_time: false,
				accurate_inuse_seconds: false,
				flag_finish: false,
				flag_eq: false,
				flag_finish_start: false,
				flag_eq_start: false,
				finish_reason: false,
				eq_reason: false,
				fromNode: false,
				hasEnergyColumns: true,
			},
			hasOrPowerStudy: {
				start_soc: false,
				end_soc: false,
			}
		},
		usage: {
			summaryField: 'usage_charger_summary',
			accurateSecondsField: 'accurate_charge_seconds'
		},
		performance: {
			hasEndVoltageReport: false,
			hasInuseEndVoltageReport: false,
			hasChargeEndVoltageReport: false,
			hasIdleEventsReport: false,
			hasImUsageDataReport: false,
			hasImPowerPeakReport: false,
			hasImTotalEnergyUsageReport: false,
			hasRegenReport: false,
			hasUsageAsReport: false,
			hasUsageTimeWidget: false,
			usageSummaryKey: 'amp_charger_usage_summary',
			kwuUsageSummaryKey: 'kw_charger_usage_summary',
			hasDataWidget: false,
			hasRelativeUsageWidget: false,
			hasBatteriesCustomizedCharts: false,
			chargeOpportunity: false,
			hasBatteryPerformance: false,
			hasPowerUsageCharts: true,
			hasUsageReport: true,
			hasTruckHoursReport: true,
			has_soc: false,
			vpc_charts: false,
			water_level_chart: false,
			hasBatteryLifeMetics: false,
			batteryPerformanceScore: false,
			hasBatteryReport: false,
			hasTruckReport: false,
		},
		customer: {
			mix_quarterly_usage_kwh: true,
		},
		quickView: {
			hasInsight: true,
			hasLiveEvent: true,
			hasLiveRT: true,
			hasWarnings: true,
			hasCalc: true,
			hasMeterGauge: false,
			hasLoadControl: false,
		},
		rts: {
			has_soc: false,
		},
	};

	getImagePath(imageType: 'not_connected' | 'connected' | 'inuse' | 'idle', options: {is_study_device: boolean} = {is_study_device : false}): string {
		let imageLink = '/images' + this.config.imageFolder;

		switch (imageType) {
			case 'not_connected':
				imageLink += `_gray_v2.png`;
				break;
			case 'connected':
				imageLink += `_connected_v2.png`;
				break;
			case 'inuse':
				imageLink = '/images/forklift_inuse.gif';
				break;
			case 'idle':
				imageLink = '/images/forklift_idle.png';
				break;
		}

		return imageLink;
	}

	getEventImage(eventType: string, is_study_device: boolean): string {
		return this.getImagePath('connected', {is_study_device});
	}

	getTypesString(options: {getPowerStudyDevices: boolean, is_study_device: boolean}): TypesString {
		return 'ChargLink';
	}
}
